import React from 'react';
import styled from 'styled-components';

const FormColumns = (props) => {
  const { children } = props;
  return <StyledFormRow>{children}</StyledFormRow>;
};

const StyledFormRow = styled.div`
  display: block;
  align-items: start;
  margin: 0 -5px;
  ${({ theme }) => `
    @media ${theme.mediumUp} {
      display: flex;
    }
  `}
  > div {
    flex: 1;
    padding-left: 5px;
    padding-right: 5px;
  }
`;

export default FormColumns;
